import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuModule as SharedMenuModule } from '@nimbus-library/features/menu/menu.module';
import { MenuAuthService } from '@nimbus-global/features/menu/services/menu-auth.service';
import { MenuProviderService } from '@nimbus-admin/features/menu/services/menu-provider.service';
import { TitleProviderService } from '@nimbus-admin/features/menu/services/title-provider.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, SharedMenuModule.forRoot(MenuProviderService, MenuAuthService, TitleProviderService)],
  exports: [SharedMenuModule],
})
export class MenuModule {}
